<!-- app.component.html -->
<div class="app-container">
  <!-- Header -->
  <app-header
    (searchClicked)="toggleSearchModal()"
    (languageChanged)="switchLanguage($event)">
  </app-header>
  
  <div class="content-wrapper">
    <!-- Left Navigation -->
    <div class="left-nav">
      <app-left-navigation></app-left-navigation>
    </div>
    
    <!-- Main Content Area -->
    <div class="main-content">
      <!-- Breadcrumb -->
      <app-breadcrumb></app-breadcrumb>
      
      <!-- Page Content -->
      <div class="page-container">
        <div class="page-content">
          <router-outlet></router-outlet>
        </div>
        
        <!-- Right Navigation -->
        <div class="right-nav">
          <app-right-navigation></app-right-navigation>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Search Modal -->
  <app-search-modal 
    *ngIf="showSearchModal" 
    (closeModal)="toggleSearchModal()">
  </app-search-modal>
</div>

<app-image-modal 
  *ngIf="showImageModal" 
  [imageUrl]="modalImageUrl" 
  [altText]="modalImageAlt"
  (close)="closeImageModal()">
</app-image-modal>